<template>
  <v-main :class="(celebrationId) ? 'pa-0' : ''">
    <v-container fluid :class="(celebrationId) ? 'pa-0' : ''">
      <v-toolbar class="elevation-0">
        <v-toolbar-title class="pl-0">Arrecadações</v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="d-flex mr-n4 align-center">
          <quicksearch v-model="quicksearch"></quicksearch>
          <v-btn v-if="!celebrationId" text color="primary" @click="modalFilter = true">
            <v-icon left>mdi-filter-outline</v-icon> Filtrar
          </v-btn>
          <v-btn text color="primary" @click="openDialog = true">
            <v-icon left>mdi-file-excel-outline</v-icon> Exportar Totalizadores
          </v-btn>
          <v-btn text color="primary" :to="{ name: 'fundraisingForm', params: { celebrationId } }">
            <v-icon left>mdi-plus-circle-outline</v-icon> Adicionar
          </v-btn>
        </div>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="items"
        :items-per-page.sync="pagination.rowsPerPage"
        :no-data-text="noResultText"
        :no-results-text="noResultText"
        loading-text="Carregando..."
        :loading="loading"
        :footer-props="{ itemsPerPageOptions: [10, 20, 30] }"
        :server-items-length="pagination.total"
        :page.sync="pagination.page"
        :sort-by.sync="pagination.sortBy"
        :sort-desc.sync="pagination.sortDesc"
      >
        <template v-slot:item.actions="{ item }">
          <v-btn :to="{ name: 'fundraisingDetails', params: { celebrationId, id: item.id } }" color="primary" fab text small dark>
            <v-icon>mdi-file-find</v-icon>
          </v-btn>
          <v-btn :to="{ name: 'fundraisingFormEdit', params: { id: item.id } }" color="primary" fab text small dark>
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
         <template v-slot:item.description="{ item }">
          {{ (item.description && item.description.length > 33) ? item.description.substr(0,30) + '...' : item.description }}
        </template>
        <template v-slot:item.unit_price="{ item }">
          {{ item.unit_price | price }}
        </template>
        <template v-slot:item.start_date="{ item }">
          {{ item.start_date | moment('MM/YYYY') }}
        </template>
        <template v-slot:item.finish_date="{ item }">
          {{ item.finish_date | moment('MM/YYYY') }}
        </template>
        <template v-slot:item.created_at="{ item }">
          {{ item.created_at | moment('DD/MM/YYYY hh:mm:ss') }}
        </template>
      </v-data-table>
    </v-container>
    <filter-modal v-if="!celebrationId" :open="modalFilter" page="fundraisings" title="Arrecadações" @close="modalFilter = false"></filter-modal>
    <excel-fundraising-dialog :visible="openDialog" :fundraisings="ids" @close="openDialog = false"></excel-fundraising-dialog>
  </v-main>
</template>

<script>
import axios from 'axios'
import FilterModal from '@/components/FilterModal'
import Quicksearch from '@/components/Quicksearch'
import ExcelFundraisingDialog from '@/components/ExcelFundraisingDialog'
import { mapGetters } from 'vuex'

export default {
  name: 'fundraisings',
  components: {
    Quicksearch,
    FilterModal,
    ExcelFundraisingDialog
  },
  props: ['celebrationId'],
  data: () => ({
    loading: false,
    openDialog: false,
    modalFilter: false,
    quicksearch: '',
    items: [],
    headers: [
      {
        text: '',
        sortable: false,
        value: 'actions'
      },
      {
        text: 'Nome',
        value: 'name'
      },
      {
        text: 'Descrição',
        sortable: false,
        value: 'description'
      },
      {
        text: 'Valor total',
        sortable: false,
        align: 'right',
        value: 'unit_price'
      },
      {
        text: 'Inicia em',
        value: 'start_date'
      },
      {
        text: 'Termina em',
        value: 'finish_date'
      },
      {
        text: 'Criado em',
        value: 'created_at'
      }
    ],
    pagination: {
      rowsPerPage: 20,
      page: 1,
      total: 0,
      sortBy: [],
      sortDesc: []
    }
  }),
  computed: {
    ...mapGetters(['searchParams']),
    ids () {
      return this.items.map(e => e.id)
    },
    noResultText () {
      return 'Nenhuma arrecadação cadastrada'
    },
    params () {
      let params = '?page[size]=' + this.pagination.rowsPerPage + '&page[number]=' + this.pagination.page
      if (this.quicksearch.length > 0) params += '&filter[q]=' + this.quicksearch
      if (this.celebrationId) params += '&filter[celebration_id]=' + this.celebrationId
      for (let key in this.searchParams('fundraisings')) {
        if (this.searchParams('fundraisings')[key]) {
          if (Array.isArray(this.searchParams('fundraisings')[key])) params += '&filter[' + key + ']=' + this.searchParams('fundraisings')[key].join()
          else params += '&filter[' + key + ']=' + this.searchParams('fundraisings')[key]
        }
      }
      for (let i = 0, l = this.pagination.sortBy.length; i < l; i++) {
        if (i === 0) params += '&sort='
        else params += ','
        if (this.pagination.sortDesc[i]) params += '-'
        params += this.pagination.sortBy[i]
      }
      return params
    }
  },
  watch: {
    params () {
      this.getData()
    }
  },
  methods: {
    getData () {
      let vue = this
      vue.loading = true

      axios.get('fundraisings' + vue.params)
        .then(response => {
          vue.items = response.data.data
          vue.loading = false
          vue.pagination.total = response.data.meta.total
        })
        .catch(() => {
          vue.loading = false
          vue.items = []
          vue.pagination.total = 0
        })
    }
  },
  created () {
    this.getData()
  }
}
</script>
